var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330 330",
    style: {
      enableBackground: "new 0 0 330 330"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    d: "M165,7.5c-8.284,0-15,6.716-15,15v60c0,8.284,6.716,15,15,15c8.284,0,15-6.716,15-15v-60 C180,14.216,173.284,7.5,165,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    d: "M165,262.5c-8.284,0-15,6.716-15,15v30c0,8.284,6.716,15,15,15c8.284,0,15-6.716,15-15v-30 C180,269.216,173.284,262.5,165,262.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    d: "M315,157.5h-60c-8.284,0-15,6.716-15,15s6.716,15,15,15h60c8.284,0,15-6.716,15-15S323.284,157.5,315,157.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    d: "M90,172.5c0-8.284-6.716-15-15-15H15c-8.284,0-15,6.716-15,15s6.716,15,15,15h60 C83.284,187.5,90,180.784,90,172.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    d: "M281.673,55.827c-5.857-5.858-15.355-5.858-21.213,0l-42.427,42.427c-5.858,5.858-5.858,15.355,0,21.213 c2.929,2.929,6.768,4.394,10.606,4.394c3.839,0,7.678-1.464,10.607-4.394l42.427-42.427 C287.531,71.182,287.531,61.685,281.673,55.827z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_85_",
    d: "M90.753,225.533L48.328,267.96c-5.857,5.858-5.857,15.355,0,21.213c2.929,2.929,6.768,4.393,10.607,4.393 c3.839,0,7.678-1.464,10.607-4.393l42.426-42.427c5.857-5.858,5.857-15.355,0-21.213 C106.109,219.675,96.612,219.675,90.753,225.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_86_",
    d: "M69.541,55.827c-5.858-5.858-15.355-5.857-21.213,0c-5.858,5.858-5.858,15.355,0,21.213l42.426,42.427 c2.93,2.929,6.768,4.394,10.607,4.394c3.838,0,7.678-1.465,10.606-4.393c5.858-5.858,5.858-15.355,0-21.213L69.541,55.827z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.8bc920baf22415a468d92cc8020a6755.svg";
export { ForwardRef as ReactComponent };